import api from "./apiService";

export const myWallet = async (token = localStorage.getItem("token")) => {
  const config = {};

  if (token) {
    config.headers = {
      Authorization: `Bearer ${token}`,
    };
  }

  return await api.get("/wallet/fetch-wallet", config);
};



export const fetchTransactions = async (token, params = {}) => {
  return await api.get("/wallet/fetch-transactions", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params,
  });
};
